import React from "react";
import "./header.scss";
import ThemeSwitch from "../themeSwitch/themeSwitch";
import classNames from "classnames";
export interface HeaderProps {
  onChange: (type: "sun" | "moon") => void;
}
const Header = ({ onChange }: HeaderProps) => {
  const [theme, setTheme] = React.useState<"sun" | "moon">("sun");
  const handleChangeTheme = (type: "sun" | "moon") => {
    setTheme(type);
    onChange(type);
  };
  const classString = classNames("live-demo-header", {
    "live-demo-header-dark": theme === "moon",
  });
  return (
    <div className={classString}>
      <div className="window-control-bar">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="theme-button">
        <ThemeSwitch onChange={handleChangeTheme}></ThemeSwitch>
      </div>
    </div>
  );
};

export default Header;
